import { ReactNode, useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import AngleDown from "@/assets/icons/ArrowDown.svg";
import { boolean } from "zod";

type TOrderStageAccordionProps = {
  children: ReactNode;
  title: string;
  stageNumber: number;
  status?: string;
  initiallyOpen?: boolean;
  disabled?: boolean;
  completed: boolean;
  isProgress: boolean;
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const OrderStageAccordion = ({
  completed = false,
  disabled = false,
  children,
  title,
  stageNumber,
  status,
  initiallyOpen = false,
  isProgress,
  isOpen,
  setIsOpen
}: TOrderStageAccordionProps) => {
  // const [isOpen, setIsOpen] = useState(initiallyOpen);
  const contentRef = useRef<HTMLDivElement>(null);

  const toggleOpen = () => {
    if (!disabled) {
      setIsOpen((prev) => !prev);
    }
  };

  return (
    <div className="w-full border-[1.5px] rounded-xl overflow-hidden">
      <motion.div
        className={`flex justify-between items-center gap-3 px-5 py-3 w-full cursor-pointer ${
          isOpen ? "bg-[#F2F4F7]" : ""
        }`}
        onClick={toggleOpen}
      >
        <div className="flex items-center gap-2 sm:gap-3">
          <div
            className={`size-5 ${
              completed && "bg-[#12B76A] text-white border-none"
            } flex justify-center items-center border-[1.5px] font-medium rounded-full text-[10px] ${
              isOpen
                ? "border-[#12B76A] text-[#12B76A]"
                : "text-[#667085] border-[#667085]"
            }`}
          >
            {stageNumber}
          </div>
          <h4
            className={`text-sm lg:text-base font-medium tracking-[-1.5%] ${
              isOpen ? "text-black" : "text-[#667085]"
            }`}
          >
            {title}
          </h4>
        </div>
        <div className="flex items-center gap-4">
          {isProgress && (
            <p className="text-xs tracking-[-3%] font-medium bg-[#FBF1DA] text-[#714B00] px-2 py-1 rounded-full inline-block border-[1.5px] border-[#714B0029] whitespace-nowrap">
              Under progress
            </p>
          )}
          {!isProgress && !completed && (
            <p className="text-xs tracking-[-3%] font-medium bg-[#F9FAFB] text-[#98A2B3] px-2 py-1 rounded-full inline-block border-[1.5px] border-[#EAEAEA] whitespace-nowrap">
              Not started yet
            </p>
          )}
          {completed && (
            <p className="text-xs tracking-[-3%] font-medium bg-[#E9F5EF] text-[#1D7100] px-2 py-1 rounded-full inline-block border-[1.5px] border-[#714B0029] whitespace-nowrap">
              Completed
            </p>
          )}
          <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.3 }}
          >
            <AngleDown />
          </motion.div>
        </div>
      </motion.div>
      {/* <AnimatePresence initial={false}> */}
      {isOpen && (
        // <motion.div {...contentAnimation} className="h-[400px] overflow-y-auto">
        <div>{children}</div>
        // </motion.div>
      )}
      {/* </AnimatePresence> */}
    </div>
  );
};

export default OrderStageAccordion;
